// 场馆大类 code 常量
export const VENUE_CODE = {
  ISLOT: 'ISLOT',
  LIVE: 'LIVE',
  SLOT: 'SLOT',
  SPORT: 'SPORT',
  ESPORTS: 'ESPORTS',
  MINI: 'MINI',
  FISH: 'FISH'
} as const

export type VenueCode = (typeof VENUE_CODE)[keyof typeof VENUE_CODE]

// 场馆大类 id => code 映射
export const VENUE_ID_TO_CODE: Record<number, VenueCode> = {
  1: VENUE_CODE.LIVE,
  2: VENUE_CODE.SLOT,
  4: VENUE_CODE.SPORT,
  5: VENUE_CODE.ESPORTS,
  7: VENUE_CODE.FISH
}
